export function formatBank(data:any) {
    const newArr = data?.map((element:any) => {
      return {
        label: element.name,
        value: `${element.code}|${element.name}`
      };
    });
    return newArr;
  }